import { siteContent } from '@/mocks/pt/siteContent';

export default function FeatureGrid() {
  const { featureGrid } = siteContent;

  return (
    <section className="px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 md:mb-12 gap-3">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            {featureGrid.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            {featureGrid.subtitle}
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {featureGrid.features.map((feature, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-lg p-6 md:p-7 transition-all duration-300 hover:bg-background-200/70"
            >
              {/* Icon */}
              <div className="w-12 h-12 rounded-lg bg-accent-100 flex items-center justify-center mb-5">
                <i className={`${feature.icon} text-accent-600 text-xl w-6 h-6 flex items-center justify-center`}></i>
              </div>

              {/* Content */}
              <h3 className="text-lg font-bold text-foreground-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}